"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addStylesToDOM;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
function addStylesToDOM(url) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new _promise["default"](function (resolve, reject) {
    var _context;
    var link = document.createElement('link');
    link.setAttribute('href', url);
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');

    // Set all given attributes
    (0, _forEach["default"])(_context = (0, _keys["default"])(attributes)).call(_context, function (key) {
      link.setAttribute(key, attributes[key]);
    });

    // Set promise callbacks
    link.onload = resolve;
    link.onerror = reject;
    document.head.appendChild(link);
  });
}